export default {
    'en': {
        demoData: 'Demo data',
    },
    'de': {
        demoData: 'Demo Daten',
    },
    'fr': {
        demoData: 'Données de démonstration',
    },
    'nl': {
        demoData: 'Demogegevens',
    },
    'el': {
        demoData: 'Δεδομένα επίδειξης',
    },
}